import { render } from "./KategorieWahl.vue?vue&type=template&id=d939729e"
import script from "./KategorieWahl.vue?vue&type=script&lang=js"
export * from "./KategorieWahl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__